import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import ReceiptEnvelope from "../components/ReceiptEnvelope";

export default function PublicReceipt() {
    const { hash } = useParams();
    const [receipt, setReceipt] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        api.publicReceipt(hash)
            .then(setReceipt)
            .catch((e) => setError(e?.response?.data?.detail || "Receipt not found"));
    }, [hash]);

    return (
        <div className="min-h-screen bg-parchment" data-testid="public-receipt-page">
            <header className="border-b border-parchment-rule">
                <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-5 flex items-baseline justify-between gap-3">
                    <Link to="/" className="flex items-baseline gap-3">
                        <span className="font-serif text-2xl text-ink">ReferralCierge</span>
                        <span className="label-eyebrow">Public receipt</span>
                    </Link>
                    <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-muted">
                        Custody · Authority · Receipts
                    </span>
                </div>
            </header>
            <main className="max-w-[1100px] mx-auto px-6 lg:px-10 py-12">
                <p className="label-eyebrow mb-3">Public-safe view</p>
                <h1 className="font-serif text-4xl tracking-tight text-ink mb-3">
                    Governance receipt
                </h1>
                <p className="text-sm text-ink-secondary max-w-2xl mb-10">
                    This page exposes only governance metadata. No bearer token, Authorization header, certificate
                    payload, full signed receipt envelope, raw private data, withheld evidence, prompts, model logs,
                    credentials or personal identifiers are shown.
                </p>
                {error ? (
                    <p className="text-oxblood text-sm" data-testid="public-receipt-error">
                        {error}
                    </p>
                ) : receipt ? (
                    <ReceiptEnvelope receipt={receipt} showPublicLink={false} />
                ) : (
                    <p className="text-sm text-ink-muted">Loading receipt…</p>
                )}
            </main>
            <footer className="border-t border-parchment-rule mt-12">
                <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-6 flex justify-between gap-3">
                    <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-muted">
                        AI may recommend. The underwriter decides. KATLAS signs the receipt.
                    </p>
                    <Link to="/" className="nav-link">Back to ReferralCierge</Link>
                </div>
            </footer>
        </div>
    );
}
